module.exports = __webpack_public_path__ + "img/img-badminton-d.8c55b2f4.png";